import { Message } from '../../shared/models/system/message';
import { Globals } from '../../shared/services/globals';
import { GenericVm } from 'src/app/shared/models/system/generic-vm';
import { Injectable } from '@angular/core';
import { HttpRequestService } from 'src/app/shared/services/http-request.service';
import { MessageEnum } from 'src/app/shared/models/system/message.enum';
import { TranslateService } from '@ngx-translate/core';
import { AdminDashboard } from 'src/app/shared/models/BasicData/AdminDashboard';

@Injectable({
  providedIn: 'root'
})
export class AdminService {

  constructor(private httpRes: HttpRequestService, private globals: Globals, private translate: TranslateService) {
  }

  statistics:AdminDashboard;

  getAllStatistics() {
    this.globals.spinner = true;
    return this.httpRes.GetRequest('admindashboard').toPromise().then(
      result => {
        this.statistics = (result as GenericVm<AdminDashboard>).data;
        this.globals.messages = (result as GenericVm<AdminDashboard>).messages;
        return this.statistics;
      }
    ).catch(
      error => {
        this.globals.messages = new Array();
        let message = new Message();
        message.type = MessageEnum.Error;
        this.translate.get('errors.server-not-available').subscribe((text: string) => message.body = text);
        this.globals.messages.push(message);
      }
    ).finally(
      () => {
        this.globals.spinner = false;
      }
    )
  }
}